import { IZonesNewZoneParams } from '../store/api/zones/types';

export const getRectPathData = (coords: IZonesNewZoneParams): string => {
  return `M ${coords.leftBottom.x} ${coords.leftBottom.y}
           L ${coords.leftTop.x} ${coords.leftTop.y}
           L ${coords.rightTop.x} ${coords.rightTop.y}
           L ${coords.rightBottom.x} ${coords.rightBottom.y} Z`;
};
